module.exports = __webpack_public_path__ + "img/book_check_out.8f78270a.svg";